import { IConfetti } from 'shared/types'
import { confettiConfig } from 'shared/config'
import { randomRange } from 'shared/utils/randomRange'

let confetti: IConfetti[] = []
let reqFrame: AnimationFrameProvider | number

export const renderConfetti = (ctx: CanvasRenderingContext2D, canvas: HTMLCanvasElement) => {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  confetti.forEach((confetto: IConfetti, index: number) => {
    const width = Number(confetto.dimensions.x) * Number(confetto.scale.x)
    const height = Number(confetto.dimensions.y) * Number(confetto.scale.y)

    ctx.translate(Number(confetto.position.x), Number(confetto.position.y))
    ctx.rotate(confetto.rotation)

    confetto.velocity.x = Number(confetto.velocity.x) - Number(confetto.velocity.x) * confettiConfig.drag
    confetto.velocity.y = Math.min(
      Number(confetto.velocity.y) + confettiConfig.gravity,
      confettiConfig.terminalVelocity
    )
    confetto.velocity.x = Number(confetto.velocity.x) + (Math.random() > 0.5 ? Math.random() : -Math.random())

    confetto.position.x = Number(confetto.position.x) + Number(confetto.velocity.x)
    confetto.position.y = Number(confetto.position.y) + Number(confetto.velocity.y)

    if (confetto.position.y >= canvas.height) confetti.splice(index, 1)

    if (confetto.position.x > canvas.width) confetto.position.x = 0
    if (confetto.position.x < 0) confetto.position.x = canvas.width

    confetto.scale.y = Math.cos(Number(confetto.position.y) * 0.1)
    ctx.fillStyle = (confetto.scale.y > 0 ? confetto.color.front : confetto.color.back) as
      | string
      | CanvasGradient
      | CanvasPattern

    ctx.fillRect(-width / 2, -height / 2, width, height)

    ctx.setTransform(1, 0, 0, 1, 0, 0)
  })

  if (confetti.length <= 10) initConfetti(canvas)

  reqFrame = window.requestAnimationFrame(() => renderConfetti(ctx, canvas))
}

export const initConfetti = (canvas: HTMLCanvasElement) => {
  confetti = []
  window.cancelAnimationFrame(reqFrame as number)
  for (let i = 0; i < confettiConfig.confettiCount; i++) {
    confetti.push({
      color: confettiConfig.colors[Math.floor(randomRange(0, confettiConfig.colors.length))],
      dimensions: {
        x: randomRange(10, 20),
        y: randomRange(10, 30)
      },

      position: {
        x: randomRange(0, canvas.width),
        y: canvas.height - 1
      },

      rotation: randomRange(0, 2 * Math.PI),
      scale: {
        x: 1,
        y: 1
      },

      velocity: {
        x: randomRange(-25, 25),
        y: randomRange(0, -50)
      }
    })
  }
}
